// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoFrame__video__3fDm-","subtreeWrapper":"VideoFrame__subtreeWrapper__W6yzZ"};